module.exports = __webpack_public_path__ + "media/images/pages/careers-week/swetha-53f6afce9d332ddd7cb915962b44f310.jpg";